import { Link } from "react-router-dom";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatBRL } from "@/lib/billing";

const INCLUDED = ["Clientes e serviços ilimitados", "Renovação automática pela validade", "Alertas, rota da semana e WhatsApp",
  "Relatório mensal para imprimir", "Usuários para a sua equipe"];

export const Pricing = ({ info }) => (
  <section id="preco" className="border-y border-slate-800 bg-slate-950/60 py-20">
    <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 sm:px-6 lg:grid-cols-2">
      <div>
        <h2 className="font-display text-3xl font-bold tracking-tight sm:text-4xl">Um plano, tudo incluído</h2>
        <p className="mt-4 text-slate-400">Comece com {info?.trial_days ?? 7} dias grátis e assine quando quiser continuar.</p>
      </div>
      <div className="rounded-2xl border border-slate-200/80 bg-slate-900 p-8 shadow-2xl" data-testid="pricing-card">
        <div className="text-sm font-semibold uppercase tracking-wider text-slate-400">Assinatura mensal</div>
        <div className="mt-3 flex items-end gap-2">
          <span className="font-display text-5xl font-extrabold" data-testid="pricing-price">{info ? formatBRL(info.monthly_price) : "—"}</span>
          <span className="pb-2 text-slate-400">/mês por empresa</span>
        </div>
        <ul className="mt-6 space-y-2.5 text-sm">
          {INCLUDED.map((i) => <li key={i} className="flex items-center gap-2"><Check className="h-4 w-4 text-emerald-400" /> {i}</li>)}
        </ul>
        <Button asChild className="mt-8 h-12 w-full rounded-full font-semibold" data-testid="pricing-cta-button">
          <Link to="/cadastro">Criar conta grátis</Link>
        </Button>
      </div>
    </div>
  </section>
);
